import { render, staticRenderFns } from "./TekenaarsItem.vue?vue&type=template&id=37a3866c&scoped=true&"
import script from "./TekenaarsItem.vue?vue&type=script&lang=js&"
export * from "./TekenaarsItem.vue?vue&type=script&lang=js&"
import style0 from "./TekenaarsItem.vue?vue&type=style&index=0&id=37a3866c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3866c",
  null
  
)

export default component.exports